/* eslint-disable react/sort-comp */
/* eslint-disable no-param-reassign */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */
import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  CloseOutlined,
  EditOutlined,
} from '@ant-design/icons';
import {
  Table, Button, Drawer, Select, Popconfirm, Alert, notification,
} from 'antd';
import Helpers from '@Apis/helpers';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import SelectDepartment from '@Components/Common/SelectDepartment';
import H3FormInput from '@Uilib/h3FormInput';
import OfferActions from '@Actions/offerActions';
import H3Image from '@Uilib/h3Image';
import H3Text from '@Uilib/h3Text';
import { QUANTITY } from '@Apis/constants';
import PurchaseRequestActions from '@Actions/purchaseRequestActions';
import SellerActions from '@Actions/sellerActions';
import ProductActions from '@Actions/productActions';
import closeIcon from '@Images/icons/icon-close-blue.png';
import { v4 as uuidv4 } from 'uuid';
import SelectOfferBulk from '@Components/Purchase/PurchaseRequests/BulkPoFromPR/BulkPRSellerSelection/SelectOfferBulk';
import BulkPreviewPo from '../BulkPreviewPo';
import TaxActions from '@Actions/taxActions';

import './style.scss';

const { Option } = Select;
/**
 * @param value
 * @param record
 * @param label
 */
class BulkPRSellerSelection extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    const innerTableColumns = [
      {
        title: 'Issuer Location',
        width: '220px',
        render: (record) => {
          const { user } = this.props;
          const { prLines } = this.state;

          const { userTenantDepartmentId, tenantDefaultStoreId } = Helpers.getUserTenantDepartmentIds(user, record.tenant_id);

          return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '200px' }}>
              <TenantSelector
                hideTitle
                selectedTenant={record.tenantId}
                showSearch={false}
                onChange={(value) => {
                  const copyData = JSON.parse(JSON.stringify(prLines));
                  copyData.map((item) => {
                    if (item.key === record.parentKey) {
                      for (let i = 0; i < item?.tenants?.length; i++) {
                        if (item?.tenants?.[i]?.key === record?.key) {
                          item.tenants[i].tenantId = value;
                          // Clear seller-related fields
                          item.tenants[i].sellerId = null;
                          item.tenants[i].tenantSellerId = null;
                          item.tenants[i].seller = null;
                          item.tenants[i].sellerInfo = null;
                          item.tenants[i].tenantSellerInfo = null;
                          // Clear department-related fields
                          item.tenants[i].departmentId = null;
                          item.tenants[i].departmentName = null;
                          item.tenants[i].tenantDepartmentId = null;
                        }
                      }
                    }
                    return item;
                  });
                  this.setState({ prLines: copyData });
                }}
                placeholder="Select Business Unit"
                labelClassName="form__input-row__label"
                includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_REQUEST, Helpers.permissionTypes.CREATE)}
                disabled={userTenantDepartmentId !== tenantDefaultStoreId}
              />
              <SelectDepartment
                hideTitle
                selectedDepartment={record.departmentId}
                onChange={(value) => {
                  const copyData = JSON.parse(JSON.stringify(prLines));
                  copyData.forEach((item) => {
                    if (item.key === record.parentKey) {
                      item.tenants?.forEach((tenant) => {
                        if (tenant.key === record.key) {
                          tenant.tenantDepartmentId = value?.tenant_department_id;
                          tenant.departmentName = value?.alias_name;
                          tenant.departmentId = value?.department_id;
                        }
                      });
                    }
                  });
                  this.setState({ prLines: copyData });
                }}
                tenantId={record.tenantId}
                labelClassName="form__input-row__label"
                emptyNotAllowed
                disabled={userTenantDepartmentId !== tenantDefaultStoreId}
              />
            </div>
          );
        },
        visible: true,
      },
      {
        title: 'VENDOR',
        width: '180px',
        render: (item, record) => {
          const { formSubmitted } = this.state;
          const {
            getAllSellerOffers,
          } = this.props;
          return (
            <Fragment>
              {!record.sellerInfo?.seller_id ? (
                <Button
                  style={{
                    fontSize: '12px',
                    borderColor: (formSubmitted && !record.sellerInfo) ? 'red' : 'default',
                    width: '150px',
                    textAlign: 'left',
                    paddingLeft: '10px',
                  }}
                  disabled={!record?.product_sku_name}
                  onClick={() => {
                    this.setState({
                      selectOfferVisible: true,
                      currentLine: {
                        ...record,
                        tenantProductId: record?.tenant_product_id,
                        productName: record?.product_sku_name,
                        productSkuId: record?.product_sku_info?.product_sku_id,
                      },
                    });
                    this.setState({
                      selectedTenants: record.tenantId,
                      selectedProductSkuId: record?.product_sku_info?.product_sku_id,
                      selectedTenantsForCurrentVendor: [record?.tenantId],
                    });
                    getAllSellerOffers(record?.product_sku_info?.product_sku_id, record?.tenantId, 1, 10);
                  }}
                >
                  Select Vendor
                </Button>
              ) : (
                <Button
                  style={{
                    fontSize: '12px',
                    width: '150px',
                    textAlign: 'left',
                    paddingLeft: '10px',
                  }}
                  onClick={() => {
                    this.setState({
                      selectOfferVisible: true,
                      currentLine: {
                        ...record,
                        tenantProductId: record?.tenant_product_id,
                        productName: record?.product_sku_name,
                        productSkuId: record?.product_sku_info?.product_sku_id,
                      },
                    });
                    this.setState({
                      selectedTenants: record.tenantId,
                      selectedProductSkuId: record?.product_sku_info?.product_sku_id,
                      selectedTenantsForCurrentVendor: [record?.tenantId],
                    });
                    getAllSellerOffers(record?.product_sku_info?.product_sku_id, record?.tenantId, 1, 10);
                  }}
                >
                  {record?.sellerInfo?.seller_name?.length > 13 ? `${record?.sellerInfo?.seller_name?.substr(0, 13)}...` : record?.sellerInfo?.seller_name}
                  <EditOutlined />
                </Button>
              )}
            </Fragment>
          );
        },
      },
      {
        title: 'BUSINESS UNIT',
        width: '110px',
        render: (text, record) => (
          <div style={{ width: '110px' }}>
            <H3Text className="table-subscript" text={record?.pr_number} />
            {`${record?.tenant_info?.tenant_name} (${record?.department_info?.department_name})`}
          </div>
        ),
      },
      {
        title: 'PURCHASED QTY',
        width: '110px',
        render: (text, record) => (
          <div style={{ width: '110px' }}>
            {`${QUANTITY(record?.total_po_quantity, record?.uom_info?.precision)} ${record?.uom_info?.uqc?.toProperCase()}`}
            <H3Text className="table-subscript" text={`${QUANTITY(record.original_qty, record?.uom_info?.precision)} ${record?.uom_info?.uqc?.toProperCase()} Requested`} />
          </div>
        ),
      },
      {
        title: 'QUANTITY',
        width: '130px',
        render: (text, record) => (
          <div style={{ width: '110px' }}>
            <H3FormInput
              value={record.quantity}
              type="number"
              containerClassName={`orgInputContainer bulk-po__tenant-table__input ${(!record.quantity) ? 'input-error' : ''}`}
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              onChange={(e) => {
                const { prLines } = this.state;
                const copyData = JSON.parse(JSON.stringify(prLines));
                copyData.map((item) => {
                  if (item.key === record.parentKey) {
                    for (let i = 0; i < item?.tenants?.length; i++) {
                      if (item?.tenants?.[i]?.key === record?.key) {
                        item.tenants[i].quantity = e.target.value;
                      }
                    }
                  }
                  return item;
                });
                this.setState({ prLines: copyData });
              }}
            />
          </div>
        ),
      },
      {
        title: 'UNIT PRICE',
        width: '130px',
        dataIndex: 'price',
        render: (text, record) => (
          <div style={{ width: '110px' }}>
            <H3FormInput
              value={record.price}
              type="number"
              containerClassName={`orgInputContainer bulk-po__tenant-table__input ${(!record.price) ? 'input-error' : ''}`}
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              onChange={(e) => {
                const { prLines } = this.state;
                const copyData = JSON.parse(JSON.stringify(prLines));
                copyData.map((item) => {
                  if (item.key === record.parentKey) {
                    for (let i = 0; i < item?.tenants?.length; i++) {
                      if (item?.tenants?.[i]?.key === record?.key) {
                        item.tenants[i].price = e.target.value;
                      }
                    }
                  }
                  return item;
                });
                this.setState({ prLines: copyData });
              }}
            />
          </div>
        ),
      },
      {
        title: 'LINE TOTAL',
        width: '110px',
        render: (text, record) => (
          <div style={{ width: '110px' }}>
            <H3Text text={this.props.MONEY((record.quantity * record.price) || '0')} />
            {(record.quantity && record.price) ? (
              <H3Text
                text={`${(record.quantity && record.price >= 0) ? this.props.MONEY(record.quantity * record.price * (1 + (record.tax_info?.tax_value / 100))) : '0'} With ${record.tax_info?.tax_value}% Tax`}
                className="table-subscript"
              />
            ) : ''}
          </div>
        ),
      },
      {
        title: '',
        width: '38px',
        render: (text, record) => (
          <div style={{ width: '20px' }}>
            <Popconfirm
              placement="topRight"
              title="Are you sure exclude this item from purchase orders? You will not be able to add it back."
              onConfirm={() => this.handleDelete(record?.parentKey, record.key)}
              okText="Yes"
              cancelText="No"
            >
              <div className="table__delete-button">
                <CloseOutlined />
              </div>
            </Popconfirm>
          </div>
        ),
        fixed: 'right',
      },
    ];
    this.state = {
      columns: [
        {
          title: '#',
          width: '30px',
          fixed: 'left',
          render: (record, index) => record?.sqn,
        },
        {
          title: 'PRODUCT',
          width: '150px',
          fixed: 'left',
          render: (record) => {
            const { formSubmitted } = this.state;
            return (
              <div style={{ width: '120px' }}>
                <div className="pr-selection__product-name">
                  {!record?.product_sku_info
                    ? (
                      <H3FormInput
                        value={record.product_sku_name}
                        type="text"
                        containerClassName={`orgInputContainer ${(formSubmitted && !record.product_sku_name) ? 'pr-selection__input-error' : ''}`}
                        labelClassName="orgFormLabel"
                        inputClassName="orgFormInput"
                        // onChange={(e) => this.updatePrLineValue(e.target.value, record, 'product_sku_name')}
                        required
                        isTextarea
                      />
                    ) : (
                      <React.Fragment>
                        {record?.product_sku_info?.product_sku_name}
                      </React.Fragment>
                    )}
                </div>
                {!record?.product_sku_info && <H3Text text="New Product" className="pr-selection__new-product" />}
              </div>
            );
          },
        },
        {
          title: 'ISSUER LOCATION',
          width: '220px',
          render: (record) => (
            <Table
              showHeader={false}
              size="small"
              scroll="scroll"
              columns={innerTableColumns}
              dataSource={JSON.parse(JSON.stringify(record?.tenants))}
              pagination={false}
              bordered
              tableLayout='fixed'
            />
          ),
          onCell: () => ({ colSpan: 6 }),
        },
        {
          title: 'VENDOR',
          width: '180px',
          render: () => (<div />),
          onCell: () => ({ colSpan: 0 }),
        },
        {
          title: 'BUSINESS UNIT',
          width: '110px',
          render: () => (<div />),
          onCell: () => ({ colSpan: 0 }),
        },
        {
          title: 'PURCHASED',
          width: '110px',
          render: () => (<div />),
          onCell: () => ({ colSpan: 0 }),
        },
        {
          title: 'QUANTITY',
          width: '130px',
          render: () => (<div />),
          onCell: () => ({ colSpan: 0 }),
        },
        {
          title: 'UNIT PRICE',
          width: '130px',
          render: () => (<div />),
          onCell: () => ({ colSpan: 0 }),
        },
        {
          title: 'LINE TOTAL',
          width: '110px',
          render: () => (<div />),
          onCell: () => ({ colSpan: 0 }),
        },
        {
          title: '',
          width: '38px',
          fixed: 'right',
          render: () => (<div />),
          onCell: () => ({ colSpan: 0 }),
        },
      ],
      formSubmitted: true,
      selectedTenantsForCurrentVendor: [],
      isUserReadyForPRs: false,
    };
  }

  /**
   *
   */
  componentDidMount() {
    const {
      getSellers, user, selectedRows, selectedTenants, getMultiplePurchaseRequests, getTaxes,
    } = this.props;
    getSellers('', user?.tenant_info?.tenant_id, 1, 10);
    const prIds = [];
    for (let i = 0; i < selectedRows?.length; i++) {
      prIds.push(selectedRows[i]?.purchase_requisition_id);
    }
    getMultiplePurchaseRequests({
      prIds: prIds?.join(','),
      tenantIds: selectedTenants,
    }, (purchaseRequests) => {});
    getTaxes(user?.tenant_info?.org_id, 1, 1000, null, true, (data) => {
      this.setState({
        taxesGroup: data,
      });
    });
  }

  /**
   *
   * @param props
   * @param state
   * @returns {(*&{isUserReadyForPRs: boolean, prLines: unknown[]})|{isUserReadyForPRs}|*}
   */
  static getDerivedStateFromProps(props, state) {
    if (props?.multiplePurchaseRequests && !state?.isUserReadyForPRs) {
      const prLineObject = {};
      const prs = props?.multiplePurchaseRequests?.purchase_requisition;
      for (let i = 0; i < prs?.length; i++) {
        const row = prs[i];
        for (let j = 0; j < row?.purchase_requistion_lines?.length; j++) {
          const prLine = row?.purchase_requistion_lines[j];
          if (prLine?.product_sku_info) {
            const parentKey = uuidv4();
            const tenantPr = {
              key: uuidv4(),
              department_info: row?.department_info,
              tenant_id: row.issuer_tenant_id ? row.issuer_tenant_id : row.tenant_id,
              tenantId: row.issuer_tenant_id ? row.issuer_tenant_id : row.tenant_id,
              tenantDepartmentId: row.issuer_tenant_department_id ? row.issuer_tenant_department_id : row.tenant_department_id,
              departmentId: row.issuer_department_info?.department_id ? row.issuer_department_info?.department_id : row.department_id,
              departmentName: row.issuer_department_info?.department_name ? row.issuer_department_info?.department_name : row.tenant_department_alias_name,
              delivery_date: row.delivery_date,
              created_by_info: row.created_by_info,
              pr_number: row.pr_number,
              tenant_info: row?.tenant_info,
              tenant_product_id: prLine?.tenant_product_id,
              st_gen_quantity: prLine?.st_gen_quantity,
              total_po_quantity: prLine?.total_po_quantity,
              tax_info: prLine?.product_sku_info?.tax_info,
              remark: prLine?.remark,
              original_qty: prLine?.quantity,
              quantity: (prLine?.quantity - prLine?.total_po_quantity) > 0 ? (prLine?.quantity - prLine?.total_po_quantity) : 0,
              reference_ia_lines: prLine?.reference_ia_lines,
              reference_po_lines: prLine?.reference_po_lines,
              uom_info: prLine?.uom_info,
              purchase_requisition_id: prLine?.purchase_requisition_id,
              pr_line_id: prLine?.pr_line_id,
              tenant_department_id: row?.tenant_department_id,
              mo_line_id: prLine?.mo_line_id,
              product_sku_id: prLine?.product_sku_info?.product_sku_id,
              product_sku_info: prLine?.product_sku_info,
              product_sku_name: prLine?.product_sku_name,
            };
            if (!prLineObject.hasOwnProperty(prLine?.product_sku_info?.product_sku_id)) {
              prLineObject[prLine?.product_sku_info?.product_sku_id] = {
                sqn: Object.values(prLineObject)?.length + 1,
                key: parentKey,
                product_sku_id: prLine?.product_sku_info?.product_sku_id,
                product_sku_info: prLine?.product_sku_info,
                product_sku_name: prLine?.product_sku_name,
                tenants: [{
                  ...tenantPr,
                  parentKey,
                }],
              };
            } else {
              const poLineObjectItem = prLineObject[prLine?.product_sku_info?.product_sku_id];
              poLineObjectItem.tenants.push({
                ...tenantPr,
                parentKey: poLineObjectItem?.key,
              });
              prLineObject[prLine?.product_sku_info?.product_sku_id] = poLineObjectItem;
            }
          }
        }
      }
      return {
        ...state,
        prLines: Object.values(prLineObject).sort((a, b) => a.sqn - b.sqn),
        isUserReadyForPRs: true,
      };
    }
    return state;
  }

  /**
   *
   */
  componentWillUnmount() {
    const { getMultiplePurchaseRequestsSuccess } = this.props;
    getMultiplePurchaseRequestsSuccess(null);
  }

  /**
   * @param {*} value
   * @param record
   * @param key
   * @param label
   */
  handleDelete = (parentKey, key) => {
    const { prLines } = this.state;
    const updatedPrLines = JSON.parse(JSON.stringify(prLines));
    const newPrLine = [];
    for (let i = 0; i < updatedPrLines?.length; i++) {
      if (updatedPrLines[i]?.key === parentKey) {
        updatedPrLines[i].tenants = updatedPrLines[i]?.tenants?.filter((item) => item?.key !== key);
      }
      if (updatedPrLines[i].tenants?.length) newPrLine.push(updatedPrLines[i]);
    }
    this.setState({ prLines: newPrLine });
  }

  /**
   * @param {*} requestId
   * @param seller
   * @param record
   * @param lineId
   * @param {*} offer
   */
  handleSellerSelection = (record, currentLine) => {
    const { prLines, taxesGroup } = this.state;
    const { user } = this.props;
    const isVendorOverseas = record?.seller_info?.seller_type === 'OVERSEAS' && user?.tenant_info?.purchase_config?.sub_modules?.vendor?.settings?.hide_tax_for_overseas;
    for (let i = 0; i < prLines?.length; i++) {
      const tenants = prLines[i]?.tenants;
      for (let j = 0; j < tenants?.length; j++) {
        if (tenants[j].key === currentLine.key) {
          tenants[j].price = record?.offers?.[0]?.offer_price || '0';
          tenants[j].sellerInfo = {
            ...record?.seller_info,
            ...record?.offers?.[0],
          };
          tenants[j].tax_info = isVendorOverseas ? taxesGroup?.data?.find((tax) => tax?.tax_value === 0) : currentLine?.product_sku_info?.tax_info;
        }
      }
    }
    this.setState({
      prLines,
    });
  }

  /**
   *
   * @return
   */
  getTotal() {
    const { prLines } = this.state;
    let total = 0;
    const length = prLines?.length;
    if (prLines) {
      const copyData = JSON.parse(JSON.stringify(prLines));
      copyData.map((item) => {
        for (let i = 0; i < item?.tenants?.length; i++) {
          if (item?.tenants?.[i]?.quantity && item?.tenants?.[i]?.price) total += item?.tenants?.[i]?.quantity * item?.tenants?.[i]?.price * (1 + (item?.tenants?.[i]?.tax_info?.tax_value / 100));
        }
        return item;
      });
    }
    return {
      total,
      length,
    };
  }

  /**
   *
   *
   */
  convertToPo() {
    if (this.isDataValid()) {
      this.setState({ showPurchaseConfirmation: true });
    } else {
      this.setState({ formSubmitted: true });
      notification.open({
        type: 'error',
        message: 'Please select a vendor and enter quantity/unit price for every product.',
        duration: 4,
        placement: 'top',
      });
    }
  }

  /**
   *
   * @return {boolean}
   */
  isDataValid() {
    const { prLines } = this.state;
    if (prLines) {
      for (let i = 0; i < prLines?.filter((item) => item?.product_sku_info)?.length; i++) {
        const prLine = prLines[i];
        for (let j = 0; j < prLine?.tenants?.length; j++) {
          if (!prLine?.tenants[j]?.quantity || prLine?.tenants[j]?.quantity <= 0 || !prLine?.tenants[j]?.price || !prLine?.tenants[j]?.sellerInfo || prLine?.tenants[j]?.price <= 0) return false;
        }
      }
    }
    return true;
  }

  /**
   *
   * @param data
   * @return {any}
   */
  getDataSource(data) {
    if (data) {
      return JSON.parse(JSON.stringify(data?.filter((item) => item?.product_sku_info)));
    }
    return [];
  }

  /**
   *
   * @return
   */
  render() {
    const {
      getPurchaseRequestByIdLoading, sellers, toggleBulkPoDrawer, MONEY,
    } = this.props;
    const {
      columns, selectOfferVisible, currentLine, showPurchaseConfirmation, prLines, selectedTenants, selectedProductSkuId, selectedTenantsForCurrentVendor,
    } = this.state;
    return (
      <React.Fragment>
        {getPurchaseRequestByIdLoading
          ? (
            <div className={`${window.location.href.includes('/purchase/purchase-request/vendor-selection/') ? 'pr-selection__preview-page pr-selection__loading__wrapper' : 'pr-selection__loading__wrapper'} pr-selection__preview-container`}>
              {[1, 2, 3, 4, 5].map((item) => (
                <div key={item} className="pr-selection__loading__wrapper-row">
                  <div className="pr-selection__loading__wrapper-row__label loadingBlock" />
                  <div className="pr-selection__loading__wrapper-row__value loadingBlock" />
                </div>
              ))}
              <div className="pr-selection__loading__wrapper-table loadingBlock" />
            </div>
          ) : (
            <div className={`${window.location.href.includes('/purchase/purchase-request/vendor-selection/') ? ' pr-selection__preview-page' : ''} pr-selection__preview-container `}>
              <SelectOfferBulk
                selectOfferVisible={selectOfferVisible}
                toggleOfferModal={() => this.setState({ selectOfferVisible: !selectOfferVisible })}
                currentLine={currentLine}
                handleSellerSelection={this.handleSellerSelection}
                type="order"
                productSkuId={selectedProductSkuId}
                tenantIds={selectedTenants}
                selectedTenantsForCurrentVendor={selectedTenantsForCurrentVendor}
              />
              <div className="bulkpr-warning">
                <Alert
                  message="ADHOC/New products cannot be added in bulk purchase orders."
                  showIcon
                  type="info"
                />
              </div>
              <div style={{ marginBottom: '80px' }} className="bulk-po-items-table">
                <div className="bulkpr-verify-title">
                  {`${prLines?.length} Items in this Material Request`}
                </div>
                <Table
                  showHeader={true}
                  loading={getPurchaseRequestByIdLoading || !sellers || !prLines}
                  columns={columns}
                  size="small"
                  dataSource={this.getDataSource(prLines)}
                  pagination={false}
                  bordered
                  scroll={{ x: 'max-content' }}
                  tableLayout='fixed'
                />
              </div>
              <div className={`${window.location.href.includes('/purchase/purchase-request/vendor-selection/') ? 'pr-selection__footer-container-page ' : ''} pr-selection__footer-container`}>
                <div className="pr-selection__footer-left">
                  {`${MONEY(this.getTotal().total)}`}
                  <span style={{ color: 'black', fontWeight: '400', marginLeft: '10px' }}>
                    {`(${this.getTotal()?.length || 0} Items in this Material Request)`}
                  </span>
                </div>
                <div className="po-selection__footer-right">
                  <Button
                    type="primary"
                    onClick={() => {
                      this.convertToPo();
                    }}
                  // disabled={!this.isDataValid()}
                  >
                    Verify Purchase Orders
                  </Button>
                </div>
              </div>
              <Drawer
                open={showPurchaseConfirmation}
                width="820px"
                mask
                onClose={() => this.setState({ showPurchaseConfirmation: false })}
                destroyOnClose
              >
                <div className="custom-drawer__header-wrapper">
                  <div className="custom-drawer__header" style={{ width: '880px' }}>
                    <H3Text text="Confirm Purchase Orders" className="custom-drawer__title" />
                    <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ viewGRNDrawer: false })} />
                  </div>
                </div>
                <BulkPreviewPo
                  prLines={prLines}
                  callback={() => {
                    this.setState({ showPurchaseConfirmation: false });
                    toggleBulkPoDrawer();
                  }}
                />
              </Drawer>
            </div>
          )}
      </React.Fragment>
    );
  }
}
const mapStateToProps = ({
  UserReducers, PurchaseRequestReducers, SellerReducers, TaxReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  selectedPurchaseRequest: PurchaseRequestReducers.selectedPurchaseRequest,
  getPurchaseRequestByIdLoading: PurchaseRequestReducers.getPurchaseRequestByIdLoading,
  sellers: SellerReducers.sellers,
  multiplePurchaseRequests: PurchaseRequestReducers.multiplePurchaseRequests,
});

const mapDispatchToProps = (dispatch) => ({
  getPurchaseRequestById: (prId, tenantId, callback) => dispatch(PurchaseRequestActions.getPurchaseRequestById(prId, tenantId, callback)),
  getMultiplePurchaseRequests: (params, callback) => dispatch(PurchaseRequestActions.getMultiplePurchaseRequests(params, callback)),
  getMultiplePurchaseRequestsSuccess: (multiplePurchaseRequests) => dispatch(PurchaseRequestActions.getMultiplePurchaseRequestsSuccess(multiplePurchaseRequests)),
  getAllSellerOffers: (productSkuId, tenantIds, page, limit) => dispatch(OfferActions.getAllSellerOffers(productSkuId, tenantIds, page, limit)),
  getSellers: (keyword, tenantId, page, limit, sellerId, callback) => dispatch(SellerActions.getSellers(keyword, tenantId, page, limit, sellerId, callback)),
  getProductById: (tenantId, productSkuId, tenantDepartmentId, callback) => dispatch(ProductActions.getProductById(tenantId, productSkuId, tenantDepartmentId, callback)),
  getTaxes: (tenantId, page, limit, isActive, isTaxGroup, callback) => dispatch(TaxActions.getTaxes(tenantId, page, limit, isActive, isTaxGroup, callback)),
});

BulkPRSellerSelection.propTypes = {
  getAllSellerOffers: PropTypes.func,
  user: PropTypes.any,
  getPurchaseRequestByIdLoading: PropTypes.bool,
  selectedRows: PropTypes.any,
  getSellers: PropTypes.func,
  sellers: PropTypes.any,
  toggleBulkPoDrawer: PropTypes.func,
  getMultiplePurchaseRequests: PropTypes.func,
  getMultiplePurchaseRequestsLoading: PropTypes.bool,
  multiplePurchaseRequests: PropTypes.any,
  MONEY: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BulkPRSellerSelection));
